<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { AlternativeFilterReadModel, AlternativesViewReadModel } from "@Alternatives/AlternativesViews/Domain/readmodels";

    @Component({
        props: {
            propRm: { type: Object, required: true },
            propViews: { type: Array, required: true }
        }
    })
    export default class ListFilter extends Vue
    {
        get rm(): AlternativeFilterReadModel { return this.$props.propRm as AlternativeFilterReadModel; }
        get views(): AlternativesViewReadModel[] { return this.$props.propViews as AlternativesViewReadModel[]; }

        get headerText(): string | null
        {
            if (this.rm.Data.length == 0)
            {
                return "Invalid!";
            }

            const views = this.views.filter(a => this.rm.Data.indexOf(a.Name) > -1).map(a => a.Name).sort();

            if (this.rm.Type === "MemberOf")
            {
                return `Member of: ${views.join(", ")}`;
            }
            else if (this.rm.Type === "NotMemberOf")
            {
                return `Not a member of: ${views.join(", ")}`;
            }

            return null;
        }

        deleteFilter()
        {
            this.$emit('deleteFilter', this.rm);
        }
    }
</script>

<template>
    <div class="card" style="display: inline-block;">
        <div @click="rm.IsEdited = true" class="card-header pointer">
            {{headerText}}
        </div>
        <div v-if="rm.IsEdited" class="card-body">
            <div class="form-group">
                <label>Lists:</label>
                <select class="form-control" multiple size="6" v-model="rm.Data">
                    <option v-for="v in views" :value="v.Name">{{ v.Name }}</option>
                </select>
            </div>
            <div class="d-flex justify-content-between">
                <div class="dropdown d-inline">
                    <button type="button" class="btn btn-outline-danger" data-toggle="dropdown">
                        Delete
                    </button>
                    <div class="dropdown-menu">
                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary">Cancel</button>
                            <button @click="deleteFilter" type="button" class="btn btn-danger">Confirm</button>
                        </div>
                    </div>
                </div>

                <button @click="rm.IsEdited = false" class="btn btn-primary">Update</button>
            </div>
        </div>
    </div>
</template>      


<style scoped>
</style>